import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import { deletePaymentData, getPaymentDataList } from '../../../actions/payment-data';
import PaymentDataItem from './PaymentDataItem.jsx';
import PaymentDataCreateForm from './PaymentDataCreateForm.jsx';
import { LangContext } from '../../../App.jsx';


const PaymentData = ({ list, getPaymentDataList, deletePaymentData }) => {
  const lang = useContext(LangContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (list.length === 0) getPaymentDataList().then(() => setIsLoading(true));
    else setIsLoading(true);
  }, []);


  let items = [];
  if (isLoading){
    if (list.length === 0) return <PaymentDataCreateForm cancelHidden={ true }/>;
    else items = list.map(item => <PaymentDataItem key={ item.id } { ...item } onDelete={ deletePaymentData }/>);
  }

  return <div>{ items }</div>
}

PaymentData.PropTypes = {
  isLoading: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,

  getPaymentDataList: PropTypes.func.isRequired,
  deletePaymentData: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: state.paymentData.list,
  }
};

let mapDispatchToProps = {
  getPaymentDataList,
  deletePaymentData
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  LoginRequired,
  Page
)(PaymentData);
